var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.611111 9.77778C0.611111 10.45 1.16111 11 1.83333 11H6.72222C7.39444 11 7.94444 10.45 7.94444 9.77778V3.66667C7.94444 2.99444 7.39444 2.44444 6.72222 2.44444H1.83333C1.16111 2.44444 0.611111 2.99444 0.611111 3.66667V9.77778ZM7.94444 0.611111H6.41667L5.98278 0.177222C5.87278 0.0672222 5.71389 0 5.555 0H3.00056C2.84167 0 2.68278 0.0672222 2.57278 0.177222L2.13889 0.611111H0.611111C0.275 0.611111 0 0.886111 0 1.22222C0 1.55833 0.275 1.83333 0.611111 1.83333H7.94444C8.28056 1.83333 8.55556 1.55833 8.55556 1.22222C8.55556 0.886111 8.28056 0.611111 7.94444 0.611111Z",
    fill: "#A8A8A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.b811d19f2cafea876002eb97e636fc23.svg";
export { ForwardRef as ReactComponent };